import React from "react";
import BgImg from "../../../images/case-studies/beach-bandits/beach_back.webp";

function Beachback() {
  return (
    <section
      className="beach_back"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    ></section>
  );
}

export default Beachback;
